import { SkeletonComponentBase } from '@app/shared/modules/subscriber/base/skeleton.component.base';
import { Subject, Subscription } from 'rxjs';
import { SubSink } from 'subsink';

export abstract class SubscriberComponent extends SkeletonComponentBase {
  protected readonly _subscriptions = new ExtendedSubSink();
  protected readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {
    super();
  }

  protected unsubscribe(): void {
    this._subscriptions.unsubscribe();
    this._subscriptions.loadingSubscription?.unsubscribe();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
export class ExtendedSubSink extends SubSink {
  loadingSubscription?: Subscription;
}
